// extracted by mini-css-extract-plugin
export var cancelButton = "_mk-5";
export var content = "_mk-3";
export var createButton = "_mk-6";
export var drawerContainer = "_mk-0";
export var footer = "_mk-2";
export var header = "_mk-1";
export var orderFormColumn = "_mk-4";